import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const renderImagesPreviewIsHiddenSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('hideCartGallery'),
)

export default renderImagesPreviewIsHiddenSelector
